import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const PRESETS = ["Instant", "5–15 minutes", "Under 1 hour", "1–6 hours", "Within 24 hours"];
const input = "mt-1.5 h-11 w-full border border-white/15 bg-black/40 px-3 font-mono text-sm normal-case text-white focus:border-[#a259ff] focus:outline-none";

export const DeliveryTab = () => {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setS(r.data ?? {})).catch(() => setS({}));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/settings", s);
      toast.success(s.delivery_time ? "Delivery time saved" : "Delivery time hidden");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (!s) return null;
  const value = s.delivery_time ?? "";
  return (
    <form onSubmit={save} className="mt-6 max-w-xl space-y-5" data-testid="admin-delivery-form">
      <p className="font-display text-3xl uppercase text-white">Delivery time</p>
      <p className="text-sm text-slate-300">Customers see this above the accounts, at checkout, on their order page and in their order email. Leave it empty to hide it.</p>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button type="button" key={p} onClick={() => setS({ ...s, delivery_time: p })} data-testid={`delivery-preset-${p.replace(/\W+/g, "-").toLowerCase()}`}
            className={`rounded-full border px-4 py-2 font-mono text-xs uppercase tracking-widest transition-colors ${value === p ? "border-[#a259ff] bg-[#a259ff] text-black" : "border-white/15 text-slate-300 hover:text-white"}`}>
            {p}
          </button>
        ))}
      </div>
      <label className="block font-mono text-[11px] uppercase tracking-widest text-slate-400">Or type your own
        <input maxLength={60} value={value} onChange={(e) => setS({ ...s, delivery_time: e.target.value })} placeholder="e.g. 10–30 minutes" className={input} data-testid="delivery-time-input" />
      </label>
      <div className="flex gap-3">
        <button className="h-12 bg-[#a259ff] px-8 font-mono text-xs font-bold uppercase tracking-widest text-black" data-testid="delivery-save-button">Save</button>
        {value && <button type="button" onClick={() => setS({ ...s, delivery_time: "" })} className="h-12 px-4 font-mono text-xs uppercase tracking-widest text-slate-300 hover:text-white" data-testid="delivery-clear-button">Clear</button>}
      </div>
    </form>
  );
};
